import React from "react"
import { Text, TextProps } from "@chakra-ui/react"

import useVideo from "@hooks/useVideo"

const VideoAttributes = (props: TextProps) => {
  const { video } = useVideo()

  return (
    <Text size="xs" color="text.secondary" {...props}>
      {video?.attributes?.duration} min | {video?.attributes?.publishedAt}
    </Text>
  )
}

export default VideoAttributes
